import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper/helper";
import { AgTechQueryParam } from "../enums/AgTechQueryParams.enum";
import {
  ILocationRepInfo,
  ILocationRepInfoAllResponse,
} from "../models/ILocationRepInfo.model";
import { URLConfig } from "../network/urlStore";
import { IStatusAllResponse } from "../models";
import { OdQueryParam } from "../enums";

export const getRepInfo = (
  // id: string,
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILocationRepInfoAllResponse> => {
  let url = URLConfig.getRepInfoTrialMasterURL();

  if (queryParams?.length) {
    for (const param of queryParams) {
      if (param?.value?.length) {
        url = helperFunctions.addQueryParam(url, param.key, param.value);
      }
    }
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as ILocationRepInfoAllResponse;

          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getAnalysisState = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IStatusAllResponse> => {
  let url = URLConfig.getAnalysisStateURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as IStatusAllResponse;

          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getRepInfoNextPage = (
  nextPageURI: string
): Observable<ILocationRepInfoAllResponse> => {
  const url = URLConfig.getRepInfoNextPageTrialMasterURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as ILocationRepInfoAllResponse;

          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getAllRepInfo = (
  // id: string,
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILocationRepInfo[]> => {
  let allRepInfo: ILocationRepInfo[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
      console.error("Error while fetching Rep Info data", error);
    };

    const responseHandler = (response: ILocationRepInfoAllResponse) => {
      allRepInfo = [...allRepInfo, ...(response.values || [])];

      if (response.nextPageUri) {
        getRepInfoNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
        });
      } else {
        subscriber.next(allRepInfo);
        subscriber.complete();
      }
    };

    // Initial call
    getRepInfo(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
    });
  });
};

export const getContentLengthForRepInfo = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getRepInfoTrialMasterURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};
export const updateRepInfo = (
  answerPlotLocationId: string,
  repInfoPayload: any
): Observable<number> => {
  const url = `${URLConfig.getRepInfoTrialMasterURL()}/location/${answerPlotLocationId}`;

  return new Observable((subscriber) => {
    NetworkService.patch(url, repInfoPayload).then(
      (response: any) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating repInfo", error);
      }
    );
  });
};

export const getRepBookCatalogInfo = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILocationRepInfoAllResponse> => {
  let url = URLConfig.getRepBookCatalogURL();

  if (queryParams?.length) {
    for (const param of queryParams) {
      if (param?.value?.length) {
        url = helperFunctions.addQueryParam(url, param.key, param.value);
      }
    }
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as ILocationRepInfoAllResponse;

          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};
